import CompanyNodeContentRendererV2 from "./companyNodeContentRenderer";
import CompanyTreeNodeRendererV2 from "./companyTreeNodeRenderer";

const CustomReactSortableTreeThemeV2 = {
  treeNodeRenderer: CompanyTreeNodeRendererV2,
  nodeContentRenderer: CompanyNodeContentRendererV2,
};

export default CustomReactSortableTreeThemeV2;
